export default "/_next/static/sounds/UNLOCK_5-af610e623d0484ebb781bcde4caba561.mp3";